import { createBrowserHistory, History } from 'history';

/* Single browser-history instance shared across the app.
 *
 * Centralized here so non-component modules (redux middleware, axios 401
 * handlers, upload helper, tenant verify) can navigate without going through
 * window.location.href — which forces a full page reload and breaks the SPA
 * shell. Prior to this module each route subtree instantiated its own
 * BrowserRouter with its own history, and the GA pageview listener was
 * attached to yet another unused instance. */
export const browserHistory: History = createBrowserHistory();
